<template>
  <div class="ui-content dashboard leader-sub">
    <div class="institute-drop">
      <!-- Student dropdown for parent role -->
      <div class="student-dropdown-list" v-if="students.length > 1 && isParent">
        <v-select @change="updateSelectedStudent" :items="students" v-model="selectedStudent" hide-details
          label="Select Student"></v-select>
      </div>
    </div>

    <v-card class="mx-auto normal-card">
      <div class="data-table-section prev-test-tb cat-1">
        <v-data-table :headers="headers" fixed-header :items="testList" hide-default-header hide-default-footer
          class="elevation-2 cust-table">
          <template v-slot:header="{ props: { headers } }">
            <TableHeader :headers="headers" :onSortChange="onSortChange" :orderBy="orderBy" />
          </template>
          <template v-slot:body="{ items }">
            <tbody>
              <tr v-for="item in items" :key="item.id">
                <td class="text-center rescheduletest" @click="gotoDetailedAnalysis(item)">
                  {{ item.testname }}
                </td>
                <td class="text-left">{{ item.date }}</td>
                <template v-for="(subject, idx) in item.subjects">
                  <td class="text-center" :key="'marks' + idx">
                    {{ subject.marks }}
                  </td>
                </template>
                <td class="text-center">{{ item.total.marks }}</td>
                <td class="text-center" v-if="testType!='myt'">{{ item.total.air }}</td>
              </tr>
            </tbody>
          </template>
        </v-data-table>

        <div class="tb-bottom-text">
          <div class="btm-test-prev-right">
            Click on a test name to see the detailed analysis
          </div>
        </div>
      </div>
    </v-card>

    <div class="footer-btn">
      <div class="pull-left">
        <v-btn depressed color="indigo" @click="goBack()" class="cumulative-btn">
          Back
        </v-btn>
      </div>
      <div class="pull-right">
        <Pagination :currentPage="currentPage" :totalPage="totalPages" :onPageChange="onPageChange" />
      </div>
    </div>

    <AlertBox :width="modalwidth" :onClose="onClose" :component="cComponent" :status="status" :data="alertBoxData" />
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from "vuex";
import moment from "moment";
import constants from "@/utils/constants.js";

export default {
  name: "OnlineTestWiseAnalysis",
  props: {
    // Test type: numeric value (2: ALL_INDIA_TEST, 3: PREVIOUS_YEAR, 5: MYT)
    testType: {
      type: String,
      required: true,
      validator: (value) => ["aits", "pyt", "myt"].includes(value)
    },
    // Optional student ID
    studentId: {
      type: [Number, String],
      default: null
    },
    // Optional batch ID
    batchId: {
      type: [Number, String],
      default: null
    }
  },
  mounted() {
    this.initData();
    this.checkStudentUpgraded();
  },
  data() {
    return {
      currentPage: 1,
      pageSize: 10,
      totalPages: 1,
      orderBy: {
        field: "date_answered",
        order: "DESC",
      },
      headers: [],
      testList: [],
      students: [],
      selectedStudent: null,
      currentStudentId: null,
      currentBatchId: null,
      isParent: false,
      status: false,
      alertBoxData: {},
      modalwidth: "500px",
      cComponent: "components/student/Tests/PastTests/UpgradeToPracticeSessionPopUp", 
    };
  },
  computed: {
    ...mapState("userStore", ["user", "myInstitute"]),
  },

  methods: {
    ...mapMutations("app", ["addBreadCrumbChilde"]),
    ...mapActions({
      getTestWiseAnalysisList: "resultStore/getTestTypeWiseAnalysisList",
    }),

    goBack() {
      this.$router.go(-1);
    },

    initData() {
      if (this.user.role_id == this.roleIds.PA) {
        this.initStudentData();
      } else {
        this.currentStudentId = this.studentId || this.user.id;
        this.currentBatchId = this.batchId || this.user.batch_id;
      }
      this.requestGetTestList();
    },

    updateSelectedStudent() {
      this.currentStudentId = this.selectedStudent.id;
      this.currentBatchId = this.selectedStudent.batchId;
      this.requestGetTestList();
    },

    initStudentData() {
      this.isParent = true;
      this.students = this.user.students.map((student) => {
        return {
          text: student.name,
          value: {
            id: student.id,
            batchId: student.batch_id,
          },
        };
      });
      this.selectedStudent = this.students[0].value;
      this.currentStudentId = this.selectedStudent.id;
      this.currentBatchId = this.selectedStudent.batchId;
    },

    gotoDetailedAnalysis(item) {
      let batch_id = this.currentBatchId;
      let student_test_id = item.studentTestId;
      let test_institute_id = item.testInstituteId;
      let test_name = item.testname;
      let test_id = item.id;
      let result_type = this.testType;
      let routeName = "" // Default for students (online tests)

      if (this.testType === "myt") {
        routeName = "myt-response-analysis-online";
      } else if (this.testType === "pyt") {
        routeName = "pyt-response-analysis-online";
      } else if (this.testType === "aits") {
        routeName = "aits-response-analysis-online";
      }

      // Build params based on route
      let params = {
        test_name,
        student_test_id,
        test_institute_id,
        test_id,
        batch_id,
        student_id: this.currentStudentId
      };

      // Add appropriate test type parameter
      if (routeName === "response-analysis-coordinator") {
        params.selectedTestType = result_type;
      } else if (routeName === "response-analysis-online") {
        params.result_type = result_type;
      }

      this.$router.push({
        name: routeName,
        params: params
      });
    },

    getFormattedDate(date) {
      return moment(date).format("DD/MM/YYYY");
    },

    onPageChange(e) {
      this.currentPage = e;
      this.requestGetTestList();
    },

    onSortChange() {
      this.requestGetTestList();
    },

    requestGetTestList() {
      let reqData = {
        test_type: this.testType,
        orderBy: this.orderBy,
        student_id: this.currentStudentId,
        pagination: { page: this.currentPage, pageSize: this.pageSize },
      };

      this.$root.showLoader = true;
      this.getTestWiseAnalysisList(reqData)
        .then((response) => {
          this.$root.showLoader = false;
          this.processTestList(response);
          this.totalPages = response.pagination.pageCount;
        })
        .catch((err) => {
          this.$root.showLoader = false;
          console.error("Error fetching test list:", err);
        });
    },

    generateHeaders(subjects) {
      let headers = [
        {
          hasColspan: false,
          text: "Test Name",
          hideSort: false,
          value: "name",
          class: "text-center btm-br",
        },
        {
          hasColspan: false,
          text: "Date of Test",
          hideSort: false,
          value: "date_answered",
          class: "text-left btm-br",
        },
      ];

      subjects.forEach((sub) => {
        headers.push({
          hasColspan: true,
          colSpan: 1,
          text: sub.title,
          hideSort: true,
          class: "text-center btm-br",
          cols: ["Marks"],
        });
      });

      // console.log("this.testType", this.testType); 
      if (this.testType == "aits") {
        headers.push({
          hasColspan: true,
          colSpan: 2,
          text: "Total",
          hideSort: true,
          class: "text-center btm-br",
          cols: ["Marks", "All India Rank"],
        });
      } else if(this.testType == "myt") {
        headers.push({
          hasColspan: true,
          colSpan: 1,
          text: "Total",
          hideSort: true,
          class: "text-center btm-br",
          cols: ["Marks"],
        });
      } else {
        headers.push({
          hasColspan: true,
          colSpan: 2,
          text: "Total",
          hideSort: true,
          class: "text-center btm-br",
          cols: ["Marks", "Expected A.I.R"],
        });
      }

      this.headers = headers;
    },

    async processTestList(response) {
      let testList = [];
      let allSubjects = response.batch_subjects;
      this.generateHeaders(allSubjects);

      response.list.forEach((test) => {
        let testObj = {
          subjects: [],
          testname: test.test_name,
          date: this.getFormattedDate(test.date_answered),
          studentTestId: test.student_test_id,
          id: test.id,
          testInstituteId: test.test_institute_id,
          total: {
            marks: test.your_marks,
            air: test.all_india_rank,
          }
        };

        allSubjects.forEach((subject) => {
          let subjectObj = {
            marks: "-",
            id: subject.id,
          };

          if (test.subjects) {
            let sub = test.subjects.find((s) => s.subject_id == subject.id);
            if (sub) {
              subjectObj.marks = sub.total_marks;
            }
          }
          testObj.subjects.push(subjectObj);
        });
        testList.push(testObj);
      });

      this.testList = testList;
    },

    checkStudentUpgraded() {
      if (this.testType !== "myt") {
        return false;
      }
      const modules = JSON.parse(localStorage.getItem("modules")) || [];

      let boostUpModule;
      if (this.user.institute_id !== constants.ONLINE_INSTITUTE_ID) {
        boostUpModule = modules.find(m => m.module_id === 19);
        if (boostUpModule) {
          return false;
        }
      }
      this.status = this.checkStudentUpgradedHelper(
        this.user.subscription_details
      );
      this.cComponent =
        "components/student/Tests/PastTests/UpgradeToPracticeSessionPopUp";
      (this.modalwidth = "500px"), (this.alertBoxData = {});
      return this.status;
    },
    onClose(data) {
      this.status=data.status;
      // if(data.status){
      //   this.$router.push({ name: "pyt-test-analysis" });
      // }
    },
  },

  watch: {
    testType: {
      immediate: false,
      handler(newVal) {
        if (newVal) {
          this.currentPage = 1;
          this.requestGetTestList();
        }
      }
    },

    studentId(newVal) {
      if (newVal && !this.isParent) {
        this.currentStudentId = newVal;
        this.requestGetTestList();
      }
    },

    batchId(newVal) {
      if (newVal && !this.isParent) {
        this.currentBatchId = newVal;
        this.requestGetTestList();
      }
    }
  },
};
</script>
